export default __webpack_public_path__ + "static/media/header-gift-active.798f23ba.svg";